import { useState } from "react";
import { mergeDeep } from "@apollo/client/utilities";

import { useMe, useFilterStorage } from "components/use-hooks";

const useDamageFilterHook = ({
    filter: filterParams = {},
    sort: sortParams = []
} = {}) => {
    const { me } = useMe(),
        filterStorage = useFilterStorage();

    const defaultFilter = {
        where: {
            status: {
                column: "STATUS",
                operator: "NOT_IN",
                value: ["delete"]
            },
            eeId: {
                column: "EE_ID",
                operator: "EQ",
                value: me.eeCurrentId
            }
        },
        whereStand: {
            hallName: {},
            block: {},
            standNumber: {}
        },
        activeFilters: 0
    };

    const defaultSort = [{ column: "CREATED_AT", order: "DESC" }];

    const [filter, setFilter] = useState(mergeDeep(defaultFilter, filterParams));
    const [sort, setSort] = useState([...mergeDeep(defaultSort, sortParams)]);

    filterStorage.store("view_damages", {
        filter, sort
    });

    return {
        filter: {
            data: filter,
            set: setFilter,
            reset: () => setFilter(defaultFilter)
        },
        sort: {
            data: sort,
            set: setSort,
            reset: () => setSort(defaultSort),
            default: defaultSort
        }
    };
};

export default useDamageFilterHook;
